import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Typography,
  Button,
  CircularProgress,
  withStyles,
  Grid
} from "@material-ui/core";
import FileInput from "../components/FileInput";
import { DownloadTemplate } from "../../../services/transactionService";

const styles = theme => ({
  root: {
    flexGrow: 1
  },
  progress: {
    marginLeft: 10
  }
});

class ImportTransactionApp extends Component {
  state = {
    loading: false
  };

  downloadTemplate = async () => {
    const { initials } = this.props;

    this.setState({ loading: true });
    try {
      await DownloadTemplate(initials);
    } finally {
      this.setState({ loading: false });
    }
  };

  render() {
    const { classes } = this.props;

    return (
      <div>
        <Typography variant="h4" gutterBottom component="h2">
          Import Transaction
        </Typography>
        <Grid container spacing={16} className={classes.root}>
          <Grid item xs={12}>
            <Button
              variant="contained"
              onClick={this.downloadTemplate}
              disabled={this.state.loading}
            >
              Download Template
              {this.state.loading && (
                <CircularProgress className={classes.progress} size={16} />
              )}
            </Button>
          </Grid>
          <Grid item>
            <FileInput />
          </Grid>
        </Grid>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const given_name =
    state.user.user && state.user.user.given_name
      ? state.user.user.given_name[0]
      : "N";
  const family_name =
    state.user.user && state.user.user.family_name
      ? state.user.user.family_name[0]
      : "A";

  return {
    initials: given_name + family_name
  };
}

export default connect(mapStateToProps)(
  withStyles(styles)(ImportTransactionApp)
);
